import './AutoLexiLogo.css';

const AutoLexiLogo = () => {
  return (
    <img
      src="/noBgBlack.png"
      alt="icon"
      className="small-image"
    />
  );
}

export default AutoLexiLogo;